




export default {
  name: 'drag-surface',
  computed: {
    visible() {
      return this.$store.state.runtime.dragSurface
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/drag-surface.vue